module.exports = __webpack_public_path__ + "img/time-icon.568c7ac7.png";